var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpArtGalleryPolotnoFolder {
}
_a = ApiSmpArtGalleryPolotnoFolder;
ApiSmpArtGalleryPolotnoFolder.create = (params) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        body: params,
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/polotno-folder/",
        method: "POST",
    });
});
ApiSmpArtGalleryPolotnoFolder.destroy = (id) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/polotno-folder/${id}`,
    method: "DELETE",
});
ApiSmpArtGalleryPolotnoFolder.list = (next) => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/polotno-folder/",
        method: "GET",
        next,
    });
});
ApiSmpArtGalleryPolotnoFolder.update = (_b) => {
    var { id } = _b, params = __rest(_b, ["id"]);
    return apiRequest({
        body: params,
        endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/polotno-folder/${id}`,
        method: "PATCH",
    });
};
//# sourceMappingURL=polotno_folder.js.map